<style scoped>
.letter {
  display: inline-block;
  line-height: 1em;
}
</style>
<template>
  <div class="card">
    <div class="card-header">
      {{ title }}
    </div>
    <div class="card-body">
      <strong
        ><span :ref="title" :class="id">{{ value }}</span></strong
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "card",
  data() {
    return {
      animation: null
    };
  },
  props: {
    title: {
      required: true,
      type: String
    },
    value: {
      required: true
    },
    id: {
      required: true
    }
  },
  watch: {
    value() {
      if (this.value != undefined && this.value != null) {
        this.$refs[this.title].innerHTML = "";
        [...this.value.toString()].forEach(
          c =>
            (this.$refs[this.title].innerHTML +=
              "<span class='letter'>" + c + "</span>")
        );
        this.animation = this.$anime({
          targets: "." + this.id + " .letter",
          scale: [4, 1],
          opacity: [0, 1],
          translateZ: 0,
          easing: "easeOutExpo",
          duration: 950,
          delay: function(el, i) {
            return 70 * i;
          }
        });
      }
    }
  }
};
</script>
<style></style>
